<template lang="pug">
	.login-form
		.pages.flex-col.center.align-center(:class="[!page ? '' : (page === 'login' ? 'not-flipped' : 'flipped')]")
			Loader.remember-loader(v-if="isLoading", :text="''")
				img(slot="left", src="../assets/logo_transparent.png" height="60px")
			.face.front.flex-col.space(v-else)
				.dx-card
					.login-page
						dx-validation-group
							.login-header
								img(src="../assets/logo_transparent.png" height="60px")
								div {{ $tCaption('Sign into your account') }}
							.dx-field
								dx-text-box(:value.sync="login" :disabled="processing" placeholder="Login" width="100%", :input-attr="{ placeholder: 'Login', id: 'login' }")
									dx-validator
										dx-required-rule(message="Login is required")
							.dx-field
								dx-text-box(
									:value.sync="password"
									:disabled="processing"
									:useMaskedValue="true"
									:input-attr="{ placeholder: $tCaption('Password'), id: 'password' }"
									placeholder="Password"
									width="100%"
									mode="password"
								)
							.dx-field
								dx-check-box(:value.sync="rememberStorage.value" :text="$tCaption('Remember me')")
							.dx-field
								dx-button(
									@click="onLoginClick"
									:disabled="processing"
									type="default"
									text="Login"
									width="100%"
								)
							.dx-field
								router-link(to="/recovery")
									a Forgot password?
							.dx-field
								dx-button(type="normal" text="Create an account" width="100%", @click="onCreateAccountClick")
				.flex-row.full-width.justify-center
					.font-small.grey Version {{$auth.getVersion()}}
			.face.back.dx-card
				Registration(v-if="page === 'registration'", :inviteData="!doNotUseInviteData && inviteData", :companyInvite="companyInvite", :companyInviteData="!doNotUseInviteData && companyInviteData", :emailValidationData="emailValidation", @registered="onRegistered")
					.dx-field(slot="bottom")
						dx-button(type="normal" text="Back to login" width="100%", @click="onBackToLogin")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxValidationGroup from 'devextreme-vue/validation-group';
	import DxValidator, { DxRequiredRule } from 'devextreme-vue/validator';
	import Registration from 'view/user/Registration.vue';
	import Loader from 'app-core/Loader.vue';
	import loginCore from './login-core';

	export default {
		translationCategory: 'login-form',
		components: {
			DxButton, DxCheckBox, DxTextBox, DxValidator, DxRequiredRule, DxValidationGroup, Registration, Loader
		},
		mixins: [loginCore]
	};
</script>

<style lang="scss">
	@import "../themes/generated/variables.base.scss";

	.login-form {
		input:-webkit-autofill,
		input:-webkit-autofill:hover,
		input:-webkit-autofill:focus,
		input:-webkit-autofill:active  {
			-webkit-box-shadow: 0 0 0 30px white inset !important;
		}

		.remember-loader {
			font-size: 30px;
		}

		.login-page {
			width: 240px;
		}

		.login-header {
			text-align: center;
			margin-bottom: 40px;

			.title {
				color: $base-accent;
				font-weight: bold;
				font-size: 30px;
				margin: 0;
			}
		}

		.dx-card {
			width: auto !important;
		}

		.pages {
			position: relative;
			height: 740px;

			.face {
				position: absolute;
				backface-visibility: hidden;
				z-index: 0;
			}

			.back {
				transform: rotateY(180deg);
			}
		}

		/* ANIMATIONS */
		.flipped {
			transform-style: preserve-3d;
			animation: 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s 1 normal both running flip-horizontal-bottom;
		}

		.not-flipped {
			transform-style: preserve-3d;
			animation: 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955) 0s 1 normal both running flip-horizontal-bottom-back;
		}

		@keyframes flip-horizontal-bottom {
			0% {
				transform: translateZ(0) rotateY(0);
			}
			100% {
				transform: translateZ(160px) rotateY(180deg);
			}
		}

		@keyframes flip-horizontal-bottom-back {
			0% {
				transform: translateZ(160px) rotateY(180deg);
			}
			100% {
				transform: translateZ(0) rotateY(0);
			}
		}
	}
</style>
